<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m14 6.5v-2h-4v2zm-10 2v11h16v-11zm16-2c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2h-16c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4v-2c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2z"
    />
  </svg>
</template>
